import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  title = new BehaviorSubject(null);
  progressPercent = new BehaviorSubject(0);
  constructor(private spinner: NgxSpinnerService) {
    // console.log(' private spinner: NgxSpinnerService ')
    // this.show();
    // this.progressPercent.subscribe(val => {
    //     setTimeout(() => {
    //         if (val > 100) {
    //             this.progressPercent.next(1);
    //         } else {
    //             this.progressPercent.next((val + 1));
    //         }
    //     }, 200);
    // })
  }

  updateTitle(title: string) {
    this.title.next(title as any);
  }
  show() {
    //   this.title.next(this.translate.getValue(title))
    this.spinner.show(undefined, {
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      size: 'medium',
      type: 'ball-scale-multiple',
      // fullScreen: true
    });
  }
  hide() {
    this.spinner.hide();
  }
}
